// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__34xYe","spin":"Loader_spin__1aHkG"};